<span class="previously-bought-badge" [class.inverted]="inverted">{{ 'PREVIOUSLY_BOUGHT' | translate }}</span>
